import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useSurfaceStore } from 'pinia/surface'
import type { Id } from 'types'
import SurfaceHeader from 'vuecomponents/SurfaceHeader.vue'
import SurfacePostsGrid from 'vuecomponents/SurfacePostsGrid.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceContainerGrid',
  props: {
    reactionIdsByPostId: { default: () => ({}) },
    commentIdsByPostId: { default: () => ({}) }
  },
  emits: ['scroll'],
  setup(__props: any) {





const { xHeader, backgroundLuminance, isReadOnly } = storeToRefs(useSurfaceStore())

return { __sfc: true,xHeader, backgroundLuminance, isReadOnly, SurfaceHeader, SurfacePostsGrid }
}

})